import { Theme } from '@mui/material';

export const replaceNewLineWithBreak = (content: string) => {
  return content.replace(/\n/g, '<br>');
};

// Shared green/grey convention for anything that carries power flow across the diagrams.
export const energizedColor = (theme: Theme, isEnergized?: boolean) =>
  isEnergized ? theme.palette.success.main : theme.palette.grey[400];
